import { addSavedItem as addSavedItemUsingSdk } from "../../../../services/savedItems";
import { SET_ITEM_SAVED_STATUS, CLEAR_ERRORS, ERROR } from "../constants";
import { LoggedError, ServiceError } from "../../../../services/errors";
import resetItemSavedStatus from "./resetItemSavedStatus";

export const addSavedItem = item => async dispatch => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({
    type: SET_ITEM_SAVED_STATUS,
    payload: { ...item, saved: true }
  });
  try {
    const { productId, colourWayId, variantId } = item;
    await addSavedItemUsingSdk({ productId, colourWayId, variantId });
  } catch (e) {
    if (e instanceof ServiceError) {
      dispatch(resetItemSavedStatus(item));

      return dispatch({
        type: ERROR,
        payload: {
          ...item,
          failedActionType: SET_ITEM_SAVED_STATUS,
          canBeRetried: false
        }
      });
    }
    throw new LoggedError(e, LoggedError.error);
  }
};
